import { useState } from 'react';

import { Typography } from 'antd';

import DraftPreview from 'components/Pages/Admin/MyEventsTabs/EventPage/Form/DraftPreview';
import { EventDetail } from 'components/Pages/Admin/TabsMyEvents/context/EventDetail';

import { CustomSalePageForm } from '../EventPageForm';

interface ICustomTemplateProps {
  eventPageData: EventDetail;
  eventId: string;
}

export const CustomTemplateV2 = ({ eventPageData, eventId }: ICustomTemplateProps) => {
  const [openPreview, setOpenPreview] = useState(false);

  return (
    <div>
      <Typography.Title level={5}>Configure sua página:</Typography.Title>

      <CustomSalePageForm eventId={eventId} eventData={eventPageData} openPreview={() => setOpenPreview(true)} />

      <DraftPreview
        open={openPreview}
        saleUrl={eventPageData.pageContent.sale_url}
        onClose={() => setOpenPreview(false)}
      />
    </div>
  );
};
